var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('HeaderComponentVue',{on:{"selected":_vm.selected}}),_c('v-main',{staticClass:"grey lighten-3"},[_c('v-window',{model:{value:(_vm.windowId),callback:function ($$v) {_vm.windowId=$$v},expression:"windowId"}},[_c('SchedulePage'),_c('ContactPage')],1)],1),_c('FooterComponentVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }